import React, { useEffect, useState } from "react";
import GoogleAdsInputContainer from "./GoogleAdsInputContainer";
import { Alert, Button, TextField } from "@mui/material";
import GoogleAdsFooterComponent from "./GoogleAdsFooterComponent";
import { handleAddGoogleAdsContent } from "../utils/helper";

export default function GoogleAds({
  revisedData,
  handleGenerateButtonClick,
  setSectionData,
  sectionData,
  formData,
  errorMessage,
  setErrorMessage,
  setIsGoogleAdsLoading,
  googleAdsLocked,
  setGoogleAdsLocked,
  setInputText,
  setSelectedLanguage,
  setMagnifiedImage,
  setShowMagnifiedTemplate,
  setTabName,
  isSidebarOpen,
  isPersonaEdited,
  googleAdsRequirementChanged,
  setIsPersonaEdited,
}) {
  const addButtonStyles = {
    background: "white",
    height: "1.5rem",
    width: "2.8rem",
    border: "0.1rem solid #26890D",
    color: "#4F4830",
    fontSize: "0.8rem",
    fontWeight: "bold",
    border: "0.1rem solid #EFC634",
    "&:hover": {
    borderColor: "#FAF0D2",
    }
  };
  
  const disabledAddButtonStyles = {
    background: "lightgray",
    height: "1.5rem",
    width: "2.8rem",
    color: "#26890D",
    fontSize: "0.8rem",
    fontWeight: "bold",
  };

  useEffect(() => {
    console.log(googleAdsRequirementChanged);
    if (
      Object.keys(sectionData.googleAds.singleAd).length === 0 ||
      Object.keys(sectionData.googleAds.carouselAd).length === 0 ||
      Object.keys(sectionData.googleAds.performanceMaxCampaign).length === 0 ||
      isPersonaEdited ||
      googleAdsRequirementChanged
    ) {
      handleGenerateButtonClick();
      setIsPersonaEdited(false);
    }
  }, []);

  const [responseValue, setResponseValue] = useState("");
  const [isLongDescEditing, setIsLongDescEditing] = useState(false);

  const handleContentEdit = () => {
    setIsLongDescEditing(true);
  };

  const handleSaveContent = () => {
    setSectionData((prevState) => {
      const sectionDataCopy = { ...prevState };
      sectionDataCopy.googleAds.carouselAd["Descriptions"] = responseValue;
      return sectionDataCopy;
    });
    setIsLongDescEditing(false);
  };

  const handleEditChange = (e) => {
    setResponseValue(e.target.value);
  };

  const handleLocks = (AdType = null, sectionTypeLock, index = null) => {
    if (AdType === "singleAd") {
      setGoogleAdsLocked((prevState) => {
        const prevLockState = { ...prevState };
        prevLockState.singleAd[sectionTypeLock][index] =
          !prevLockState.singleAd[sectionTypeLock][index];
        return prevLockState;
      });
    } else if (AdType === "carouselAd") {
      setGoogleAdsLocked((prevState) => {
        const prevLockState = { ...prevState };
        prevLockState.carouselAd[sectionTypeLock] =
          !prevLockState.carouselAd[sectionTypeLock];
        return prevLockState;
      });
    } else {
      setGoogleAdsLocked((prevState) => {
        const prevLockState = { ...prevState };
        prevLockState.performanceMax[sectionTypeLock][index] =
          !prevLockState.performanceMax[sectionTypeLock][index];
        return prevLockState;
      });
    }
  };

  const handleMagnify = (tabName, index, path) => {
    setTabName(tabName);
    setMagnifiedImage(path);
    setShowMagnifiedTemplate(true);
  };

  return (
    <div
      className={`w-full h-full flex flex-col flex-1 ${
        isSidebarOpen ? "hidden" : "block"
      } sm:block`}
    >
      <div className="flex">
        <div className="p-5 m-5 w-full bg-white rounded-lg">
          {errorMessage && (
            <Alert severity="error" sx={{ marginTop: 3, marginBottom: 3 }}>
              {errorMessage.message}
            </Alert>
          )}
          <h1 className="font-bold text-[0.9rem] p-1">SINGLE IMAGE AD</h1>
          <div className="flex justify-between align-center">
            {sectionData.googleAds.singleAd["Images"]?.length && (
              <div className="flex-shrink-0 justify-center px-2 mr-6">
                <img
                  className="h-[15rem] w-[20rem] rounded-lg"
                  key={0}
                  src={`data:image/png;base64,${sectionData.googleAds.singleAd["Images"][0]}`}
                  alt="fs"
                />
                <Button
                  sx={{
                    position: "relative",
                    zIndex: 2,
                    bottom: 232,
                    left: 50,
                    padding: 0,
                    color: "grey",
                    transform: "translateX(-95%)",
                  }}
                  onClick={() =>
                    handleMagnify(
                      "generated",
                      0,
                      sectionData.googleAds.singleAd["Images"][0]
                    )
                  }
                >
                  <img
                    src={require("../assets/magnify.png")}
                    alt="magnify-Icon"
                  />
                </Button>
              </div>
            )}
            <div className="flex-1 h-[15rem] w-[70%] bg-[#F2F2F2] p-3 rounded-lg">
              <h1 className="font-bold text-[0.9rem]">Headline</h1>
              <div className="scrollable-div overflow-y-scroll max-h-[10rem] scrollbar-none">
                {sectionData.googleAds.singleAd["Headlines"]?.length &&
                  sectionData.googleAds.singleAd["Headlines"]?.map(
                    (headline, key) =>
                      headline?.length ? (
                        <GoogleAdsInputContainer
                          value={key}
                          content={headline}
                          AdType="singleAd"
                          sectionTypeLock="headlinesLock"
                          setSectionData={setSectionData}
                          isLocked={
                            googleAdsLocked.singleAd["headlinesLock"][key]
                          }
                          setGoogleAdsLocked={setGoogleAdsLocked}
                          handleLocks={handleLocks}
                          setInputText={setInputText}
                          setSelectedLanguage={setSelectedLanguage}
                        />
                      ) : (
                        <></>
                      )
                  )}
              </div>
              <div className="flex justify-end mt-2">
                <Button
                  sx={
                    sectionData.googleAds.singleAd["Headlines"]?.length === 5
                      ? disabledAddButtonStyles
                      : addButtonStyles
                  }
                  onClick={() => {
                    handleAddGoogleAdsContent(
                      "singleAd",
                      "headline",
                      sectionData,
                      setSectionData,
                      formData,
                      setIsGoogleAdsLoading,
                      setGoogleAdsLocked,
                      setErrorMessage
                    );
                  }}
                  disabled={
                    sectionData.googleAds.singleAd["Headlines"]?.length === 5
                      ? true
                      : false
                  }
                >
                  Add
                  <img
                    className="pl-1 h-[0.8rem] width-[0.9rem]"
                    src={
                      sectionData.googleAds.singleAd["Headlines"]?.length === 5
                        ? require(`../assets/AddStep.png`)
                        : require(`../assets/addstep1.png`)
                    }
                  />
                </Button>
              </div>
            </div>
          </div>

          <div className="w-[100%] bg-[#F2F2F2] p-3 mt-4 rounded-lg">
            <h1 className="font-bold text-[0.9rem]">Description</h1>
            <div className="scrollable-div overflow-y-scroll max-h-[10rem] scrollbar-none">
              {sectionData.googleAds.singleAd["Descriptions"]?.length &&
                sectionData.googleAds.singleAd["Descriptions"]?.map(
                  (description, key) =>
                    description?.length ? (
                      <GoogleAdsInputContainer
                        value={key}
                        content={description}
                        AdType="singleAd"
                        sectionTypeLock="descriptionsLock"
                        setSectionData={setSectionData}
                        isLocked={
                          googleAdsLocked.singleAd["descriptionsLock"][key]
                        }
                        setGoogleAdsLocked={setGoogleAdsLocked}
                        handleLocks={handleLocks}
                        setInputText={setInputText}
                        setSelectedLanguage={setSelectedLanguage}
                      />
                    ) : (
                      <></>
                    )
                )}
            </div>
            <div className="flex justify-end mt-2.5">
              <Button
                sx={
                  sectionData.googleAds.singleAd["Descriptions"]?.length === 5
                    ? disabledAddButtonStyles
                    : addButtonStyles
                }
                onClick={() =>
                  handleAddGoogleAdsContent(
                    "singleAd",
                    "description",
                    sectionData,
                    setSectionData,
                    formData,
                    setIsGoogleAdsLoading,
                    setGoogleAdsLocked,
                    setErrorMessage
                  )
                }
                disabled={
                  sectionData.googleAds.singleAd["Descriptions"]?.length === 5
                    ? true
                    : false
                }
              >
                Add
                <img
                  className="pl-1 h-[0.8rem] width-[0.9rem]"
                  src={
                    sectionData.googleAds.singleAd["Descriptions"]?.length === 5
                      ? require(`../assets/AddStep.png`)
                      : require(`../assets/addstep1.png`)
                  }
                />
              </Button>
            </div>
          </div>

          <GoogleAdsFooterComponent
            handleGenerateButtonClick={handleGenerateButtonClick}
            callToAction={sectionData.googleAds.singleAd["Call to Action"]}
            AdType="SingleAd"
            flagRegenerated={true}
            revisedData={revisedData}
          />
        </div>
      </div>

      <div className="flex">
        <div className="p-5 m-5 w-full bg-white rounded-lg">
          <h1 className="font-bold text-[0.9rem] p-1">CAROUSEL AD</h1>

          <div className="w-[100%] p-3 mt-4 rounded-lg">
            <h1 className="font-bold text-[0.9rem]">Headline</h1>
            {sectionData.googleAds.carouselAd["Headlines"]?.length && (
              <GoogleAdsInputContainer
                value={null}
                content={sectionData.googleAds.carouselAd["Headlines"]}
                AdType="carouselAd"
                sectionTypeLock="headlinesLock"
                setSectionData={setSectionData}
                isLocked={googleAdsLocked.carouselAd["headlinesLock"]}
                setGoogleAdsLocked={setGoogleAdsLocked}
                handleLocks={handleLocks}
                setInputText={setInputText}
                setSelectedLanguage={setSelectedLanguage}
              />
            )}
          </div>

          <div className="w-[100%] p-3 mt-4 rounded-lg">
            <h1 className="font-bold text-[0.9rem]">Description</h1>
            <div className="h-[8rem] w-[100%] bg-white rounded-lg mt-2 border-2 flex flex-col justify-between border-gray-250 p-2">
              {isLongDescEditing ? (
                <TextField
                  variant="standard"
                  fullwidth
                  multiline
                  defaultValue={
                    sectionData.googleAds.carouselAd["Descriptions"]
                  }
                  onChange={handleEditChange}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  inputRef={(input) => input && input.focus()}
                  onFocus={(e) =>
                    e.currentTarget.setSelectionRange(
                      e.currentTarget.value.length,
                      e.currentTarget.value.length
                    )
                  }
                />
              ) : (
                <p className="whitespace-normal">
                  {sectionData.googleAds.carouselAd["Descriptions"]}
                </p>
              )}
              <div className="flex justify-end">
                {isLongDescEditing ? (
                  <Button>
                    <img
                      className="h-[1.2rem] w-[1.2rem]"
                      src={require(`../assets/saveIcon.png`)}
                      alt="save-Icon"
                      onClick={handleSaveContent}
                    />
                  </Button>
                ) : (
                  <Button>
                    <img
                      className="h-[1.2rem] w-[1.2rem]"
                      src={require(`../assets/edit-icon.png`)}
                      alt="edit-Icon"
                      onClick={handleContentEdit}
                    />
                  </Button>
                )}
                <Button>
                  <img
                    className="h-[1.2rem] w-[1.2rem]"
                    src={
                      googleAdsLocked.carouselAd["descriptionsLock"]
                        ? require(`../assets/content-lock.jpg`)
                        : require(`../assets/content-unlock.jpg`)
                    }
                    onClick={() =>
                      handleLocks("carouselAd", "descriptionsLock")
                    }
                    alt="locked-Icon"
                  />
                </Button>
              </div>
            </div>
          </div>

          <div className="flex justify-evenly align-center w-[100%] flex-wrap">
            {sectionData.googleAds.carouselAd["Images"]?.length &&
              sectionData.googleAds.carouselAd["Images"].map((image, key) => (
                <div className="flex-shrink-0 overflow-x-scroll scroll-width-none flex-no-wrap justify-center px-2 mr-6">
                  <img
                    className="h-[13rem] w-[12rem] rounded-lg"
                    key={key}
                    src={`data:image/png;base64,${image}`}
                    alt="fs"
                  />
                  <Button
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      bottom: 205,
                      left: 43,
                      padding: 0,
                      color: "grey",
                      transform: "translateX(-95%)",
                    }}
                    onClick={() => handleMagnify("generated", key, image)}
                  >
                    <img
                      src={require("../assets/magnify.png")}
                      alt="magnify-Icon"
                    />
                  </Button>
                </div>
              ))}
          </div>

          <GoogleAdsFooterComponent
            handleGenerateButtonClick={handleGenerateButtonClick}
            callToAction={sectionData.googleAds.carouselAd["Call to Action"]}
            AdType="carouselAd"
            flagRegenerated={true}
            revisedData={revisedData}
          />
        </div>
      </div>

      <div className="flex">
        <div className="p-5 m-5 w-full bg-white rounded-lg">
          <h1 className="font-bold text-[0.9rem] p-1">
            PERFORMANCE MAX CAMPAIGN
          </h1>

          <div className="w-[100%] bg-[#F2F2F2] p-3 rounded-lg">
            <h1 className="font-bold text-[0.9rem]">Headline</h1>
            <div className="scrollable-div overflow-y-scroll max-h-[10rem] scrollbar-none">
              {sectionData.googleAds.performanceMaxCampaign["Headlines"]
                ?.length &&
                sectionData.googleAds.performanceMaxCampaign["Headlines"].map(
                  (headline, key) =>
                    headline?.length ? (
                      <GoogleAdsInputContainer
                        value={key}
                        content={headline}
                        AdType="performanceMaxCampaign"
                        sectionTypeLock="headlinesLock"
                        setSectionData={setSectionData}
                        isLocked={
                          googleAdsLocked.performanceMax["headlinesLock"][key]
                        }
                        setGoogleAdsLocked={setGoogleAdsLocked}
                        handleLocks={handleLocks}
                        setInputText={setInputText}
                        setSelectedLanguage={setSelectedLanguage}
                      />
                    ) : (
                      <></>
                    )
                )}
            </div>
            <div className="flex justify-start mt-2">
              <Button
                sx={
                  sectionData.googleAds.performanceMaxCampaign["Headlines"]
                    ?.length === 11
                    ? disabledAddButtonStyles
                    : addButtonStyles
                }
                onClick={() =>
                  handleAddGoogleAdsContent(
                    "performanceMaxAd",
                    "headline",
                    sectionData,
                    setSectionData,
                    formData,
                    setIsGoogleAdsLoading,
                    setGoogleAdsLocked,
                    setErrorMessage
                  )
                }
                disabled={
                  sectionData.googleAds.performanceMaxCampaign["Headlines"]
                    ?.length === 11
                    ? true
                    : false
                }
              >
                Add
                <img
                  className="pl-1 h-[0.8rem] width-[0.9rem]"
                  src={
                    sectionData.googleAds.performanceMaxCampaign["Headlines"]
                      ?.length === 11
                      ? require(`../assets/AddStep.png`)
                      : require(`../assets/addstep1.png`)
                  }
                />
              </Button>
            </div>
          </div>

          <div className="w-[100%] bg-[#F2F2F2] p-3 mt-4 rounded-lg">
            <h1 className="font-bold text-[0.9rem]">Long Headlines</h1>
            <div className="scrollable-div overflow-y-scroll max-h-[10rem] scrollbar-none">
              {sectionData.googleAds.performanceMaxCampaign["Long_Headlines"]
                ?.length &&
                sectionData.googleAds.performanceMaxCampaign[
                  "Long_Headlines"
                ].map((longHeadline, key) =>
                  longHeadline?.length ? (
                    <GoogleAdsInputContainer
                      value={key}
                      content={longHeadline}
                      AdType="performanceMaxCampaign"
                      sectionTypeLock="longHeadlinesLock"
                      setSectionData={setSectionData}
                      isLocked={
                        googleAdsLocked.performanceMax["longHeadlinesLock"][key]
                      }
                      setGoogleAdsLocked={setGoogleAdsLocked}
                      handleLocks={handleLocks}
                      setInputText={setInputText}
                      setSelectedLanguage={setSelectedLanguage}
                    />
                  ) : (
                    <></>
                  )
                )}
            </div>
            <div className="flex justify-start mt-2">
              <Button
                sx={
                  sectionData.googleAds.performanceMaxCampaign["Long_Headlines"]
                    ?.length === 2
                    ? disabledAddButtonStyles
                    : addButtonStyles
                }
                onClick={() =>
                  handleAddGoogleAdsContent(
                    "performanceMaxAd",
                    "longHeadline",
                    sectionData,
                    setSectionData,
                    formData,
                    setIsGoogleAdsLoading,
                    setGoogleAdsLocked,
                    setErrorMessage
                  )
                }
                disabled={
                  sectionData.googleAds.performanceMaxCampaign["Long_Headlines"]
                    ?.length === 2
                    ? true
                    : false
                }
              >
                Add
                <img
                  className="pl-1 h-[0.8rem] width-[0.9rem]"
                  src={
                    sectionData.googleAds.performanceMaxCampaign[
                      "Long_Headlines"
                    ]?.length === 2
                      ? require(`../assets/AddStep.png`)
                      : require(`../assets/addstep1.png`)
                  }
                />
              </Button>
            </div>
          </div>

          <div className="w-[100%] bg-[#F2F2F2] p-3 rounded-lg mt-4">
            <h1 className="font-bold text-[0.9rem]">Description</h1>
            <div className="scrollable-div overflow-y-scroll max-h-[10rem] scrollbar-none">
              {sectionData.googleAds.performanceMaxCampaign["Descriptions"]
                ?.length &&
                sectionData.googleAds.performanceMaxCampaign[
                  "Descriptions"
                ].map((description, key) =>
                  description?.length ? (
                    <GoogleAdsInputContainer
                      value={key}
                      content={description}
                      AdType="performanceMaxCampaign"
                      sectionTypeLock="descriptionsLock"
                      setSectionData={setSectionData}
                      isLocked={
                        googleAdsLocked.performanceMax["descriptionsLock"][key]
                      }
                      setGoogleAdsLocked={setGoogleAdsLocked}
                      handleLocks={handleLocks}
                      setInputText={setInputText}
                      setSelectedLanguage={setSelectedLanguage}
                    />
                  ) : (
                    <></>
                  )
                )}
            </div>
            <div className="flex justify-start mt-2">
              <Button
                sx={
                  sectionData.googleAds.performanceMaxCampaign["Descriptions"]
                    ?.length === 4
                    ? disabledAddButtonStyles
                    : addButtonStyles
                }
                onClick={() =>
                  handleAddGoogleAdsContent(
                    "performanceMaxAd",
                    "description",
                    sectionData,
                    setSectionData,
                    formData,
                    setIsGoogleAdsLoading,
                    setGoogleAdsLocked,
                    setErrorMessage
                  )
                }
                disabled={
                  sectionData.googleAds.performanceMaxCampaign["Descriptions"]
                    ?.length === 4
                    ? true
                    : false
                }
              >
                Add
                <img
                  className="pl-1 h-[0.8rem] width-[0.9rem]"
                  src={
                    sectionData.googleAds.performanceMaxCampaign["Descriptions"]
                      ?.length === 4
                      ? require(`../assets/AddStep.png`)
                      : require(`../assets/addstep1.png`)
                  }
                />
              </Button>
            </div>
          </div>

          <GoogleAdsFooterComponent
            handleGenerateButtonClick={handleGenerateButtonClick}
            callToAction={
              sectionData.googleAds.performanceMaxCampaign["Call to Action"]
            }
            AdType="performanceMaxCampaignAd"
            flagRegenerated={true}
            revisedData={revisedData}
          />
        </div>
      </div>
    </div>
  );
}
